<template>
  <mf-card-container v-model="search" :title="title" useSearch placeholder="Busque um produto">
    <component
      :is="getComponent"
      class="mt-4"
      type="ungrouped"
      :products="ungroupedProducts"
      :offer-sales-type="offerSalesType"
      :headers="headers"
      :search="search"
      is-revision
      :helpers="helpers[offerSalesType]"
    />
    <template v-slot:additional-content>
      <div v-if="groupedProducts && groupedProducts.length > 0">
        <hr class="mt-4" />
        <div v-for="(group, index) in groupedProducts" :key="group._id">
          <group-card-content
            :offer-sales-type="offerSalesType"
            :group="group"
            :headers="headers"
            :group-index="index"
            :search="search"
            :helpers="helpers[offerSalesType]"
            is-revision
          />
          <hr v-if="index !== groupedProducts.length - 1" class="mt-4" />
        </div>
      </div>
    </template>
  </mf-card-container>
</template>

<script>
import AbsoluteDiscountTable from './absolute-discount/AbsoluteDiscountTable.vue'
import PercentageDiscountTable from './percentage-discount/PercentageDiscountTable.vue'
import DynamicPricingPercentageDiscountTable from './dynamic-pricing-percentage-discount/DynamicPricingPercentageDiscountTable.vue'
import TakePayTable from './take-pay/TakePayTable.vue'
import CashbackAndPointsTable from './cashback-points/CashbackAndPointsTable.vue'

import GroupCardContent from './GroupCardContent.vue'

export default {
  name: 'RevisionContainer',
  components: {
    GroupCardContent,
    AbsoluteDiscountTable,
    PercentageDiscountTable,
    DynamicPricingPercentageDiscountTable,
    TakePayTable,
    CashbackAndPointsTable,
  },
  props: {
    campaign: {
      type: Object,
      default: () => {},
    },
    offerSalesType: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    search: '',
    helpers: {
      offer_sales: {
        wrongPrices: [],
        wrongEAN: [],
        wrongQty: [],
        groupWrongPrices: [],
        groupWrongEAN: [],
        groupWrongQty: [],
      },
      percentage_offer_sales: {
        wrongPrices: [],
        wrongEAN: [],
        wrongQty: [],
        groupWrongPrices: [],
        groupWrongEAN: [],
        groupWrongQty: [],
      },
      dynamic_pricing_percentage_offer_sales: {
        wrongPrices: [],
        wrongEAN: [],
        wrongQty: [],
        groupWrongPrices: [],
        groupWrongEAN: [],
        groupWrongQty: [],
      },
      takepay_offer_sales: {
        wrongEAN: [],
        wrongTakeAndPayQty: [],
        groupWrongEAN: [],
        groupWrongTakeAndPayQty: [],
      },
      cashback_percentage_offer_sales: {
        wrongEAN: [],
        wrongQty: [],
        groupWrongEAN: [],
        groupWrongQty: [],
      },
      cashback_absolute_offer_sales: {
        wrongEAN: [],
        wrongQty: [],
        groupWrongEAN: [],
        groupWrongQty: [],
      },
      points_offer_sales: {
        wrongEAN: [],
        wrongQty: [],
        groupWrongEAN: [],
        groupWrongQty: [],
      },
      next_buy_cashback_offer_sales: {
        wrongEAN: [],
        wrongQty: [],
        groupWrongEAN: [],
        groupWrongQty: [],
      },
    },
  }),
  computed: {
    title() {
      const size = this.allSingleProducts.length
      const productLabel = size === 1 ? '1 produto com ' : `${size} produtos com `

      const titles = {
        offer_sales: productLabel + `${this.campaign.segments && this.campaign.segments.length ? 'preço 3' : 'preço 2'}`,
        percentage_offer_sales: productLabel + 'desconto percentual',
        dynamic_pricing_percentage_offer_sales: productLabel + 'desconto percentual por loja',
        takepay_offer_sales: productLabel + 'leve & pague',
        cashback_percentage_offer_sales: productLabel + 'cashback percentual',
        cashback_absolute_offer_sales: productLabel + 'cashback absoluto',
        next_buy_cashback_offer_sales: productLabel + 'cashback',
        points_offer_sales: productLabel + 'pontos',
      }

      return titles[this.offerSalesType]
    },
    ungroupedProducts() {
      return this.campaign[this.offerSalesType].filter((product) => !product.isGroup)
    },
    groupedProducts() {
      return this.campaign[this.offerSalesType].filter((product) => product.isGroup)
    },
    allSingleProducts() {
      return this.campaign[this.offerSalesType].reduce((accumulator, current) => {
        if (current.products) {
          const productsGroup = current.products.map((product) => {
            const { products, ...productWithoutGroup } = current
            return { ...productWithoutGroup, ...product }
          })
          accumulator.push(...productsGroup)
        } else {
          accumulator.push(current)
        }

        return accumulator
      }, [])
    },
    modules() {
      return this.$getAllowedModules()
    },
    isFranchise() {
      return this.$getLoggedUser().is_franchise
    },
    headers() {
      let headers = []
      if (this.offerSalesType === 'offer_sales') {
        headers = [
          {
            text: '',
            value: 'expandAction',
            width: '2%',
            sortable: false,
          },
          {
            text: '',
            value: 'image',
            width: '5%',
            sortable: false,
          },
          {
            text: 'SKU',
            value: 'sku',
            width: '10%',
            sortable: false,
          },
          {
            text: 'EAN',
            value: 'ean',
            width: '14%',
            sortable: false,
          },
          {
            text: 'Nome',
            value: 'name',
            width: '30%',
            sortable: false,
          },
          {
            text: 'Preço 1',
            value: 'price_1',
            width: '9%',
            sortable: false,
          },
          {
            text: this.campaign.segments && this.campaign.segments.length ? 'Preço 3' : 'Preço 2',
            value: 'price_2',
            width: '9%',
            sortable: false,
          },
          {
            text: 'Mín. CPF',
            value: 'minimum_per_client',
            width: '7.5%',
            sortable: false,
          },
          {
            text: 'Máx. CPF',
            value: 'maximum_per_client',
            width: '7.5%',
            sortable: false,
          },
          ...(this.isFranchise
            ? [
                {
                  text: 'Franq.',
                  value: 'franchisee_products',
                  sortable: false,
                },
              ]
            : []),
          {
            text: 'Status',
            value: 'status',
            sortable: false,
          },
        ]
      }
      if (this.offerSalesType === 'percentage_offer_sales') {
        headers = [
          {
            text: '',
            value: 'expandAction',
            width: '2%',
            sortable: false,
          },
          {
            text: '',
            value: 'image',
            width: '5%',
            sortable: false,
          },
          {
            text: 'SKU',
            value: 'sku',
            width: '14.5%',
            sortable: false,
          },
          {
            text: 'EAN',
            value: 'ean',
            width: '18.5%',
            sortable: false,
          },
          {
            text: 'Nome',
            value: 'name',
            width: '30%',
            sortable: false,
          },
          {
            text: 'Desconto',
            value: 'percentage_discount',
            width: '9%',
            sortable: false,
          },
          {
            text: 'Mín. CPF',
            value: 'minimum_per_client',
            width: '7.5%',
            sortable: false,
          },
          {
            text: 'Máx. CPF',
            value: 'maximum_per_client',
            width: '7.5%',
            sortable: false,
          },
          ...(this.isFranchise
            ? [
                {
                  text: 'Franq.',
                  value: 'franchisee_products',
                  sortable: false,
                },
              ]
            : []),
          {
            text: 'Status',
            value: 'status',
            sortable: false,
          },
        ]
      }
      if (this.offerSalesType === 'dynamic_pricing_percentage_offer_sales') {
        headers = [
          {
            text: '',
            value: 'expandAction',
            width: '2%',
            sortable: false,
          },
          {
            text: '',
            value: 'image',
            width: '5%',
            sortable: false,
          },
          {
            text: 'SKU',
            value: 'sku',
            width: '14.5%',
            sortable: false,
          },
          {
            text: 'EAN',
            value: 'ean',
            width: '18.5%',
            sortable: false,
          },
          {
            text: 'Nome',
            value: 'name',
            width: '30%',
            sortable: false,
          },
          {
            text: 'Desconto',
            value: 'percentage_discount',
            width: '9%',
            sortable: false,
          },
          {
            text: 'Mín. CPF',
            value: 'minimum_per_client',
            width: '7.5%',
            sortable: false,
          },
          {
            text: 'Máx. CPF',
            value: 'maximum_per_client',
            width: '7.5%',
            sortable: false,
          },
          ...(this.isFranchise
            ? [
                {
                  text: 'Franq.',
                  value: 'franchisee_products',
                  sortable: false,
                },
              ]
            : []),
          {
            text: 'Status',
            value: 'status',
            sortable: false,
          },
        ]
      }
      if (this.offerSalesType === 'takepay_offer_sales') {
        headers = [
          {
            text: '',
            value: 'expandAction',
            width: '2%',
            sortable: false,
          },
          {
            text: '',
            value: 'image',
            width: '5%',
            sortable: false,
          },
          {
            text: 'SKU',
            value: 'sku',
            width: '14.5%',
            sortable: false,
          },
          {
            text: 'EAN',
            value: 'ean',
            width: '18.5%',
            sortable: false,
          },
          {
            text: 'Nome',
            value: 'name',
            width: '30%',
            sortable: false,
          },
          {
            text: 'Leve',
            value: 'take',
            width: '9%',
            sortable: false,
          },
          {
            text: 'Pague',
            value: 'pay',
            width: '7.5%',
            sortable: false,
          },
          {
            text: 'Máx grupos p/ CPF',
            value: 'maximum_per_client',
            width: '7.5%',
            sortable: false,
          },
          ...(this.isFranchise
            ? [
                {
                  text: 'Franq.',
                  value: 'franchisee_products',
                  sortable: false,
                },
              ]
            : []),
          {
            text: 'Status',
            value: 'status',
            sortable: false,
          },
        ]
      }
      if (
        ['cashback_percentage_offer_sales', 'cashback_absolute_offer_sales', 'points_offer_sales', 'next_buy_cashback_offer_sales'].includes(
          this.offerSalesType
        )
      ) {
        let cashbackOrPoints = {
          width: '12%',
          sortable: false,
        }

        if (this.offerSalesType === 'cashback_percentage_offer_sales') {
          cashbackOrPoints.value = 'cashback_percentage'
          cashbackOrPoints.text = 'Cashback (%)'
        } else if (this.offerSalesType === 'cashback_absolute_offer_sales') {
          cashbackOrPoints.value = 'cashback_absolute'
          cashbackOrPoints.text = 'Cashback (R$)'
        } else if (this.offerSalesType === 'points_offer_sales') {
          cashbackOrPoints.value = 'additional_points_rate'
          cashbackOrPoints.text = 'Pontos'
        } else if (this.offerSalesType === 'next_buy_cashback_offer_sales') {
          cashbackOrPoints.value = 'cashback_absolute_discount'
          cashbackOrPoints.text = 'Cashback (R$)'
        }

        headers = [
          {
            text: '',
            value: 'expandAction',
            width: '2%',
            sortable: false,
          },
          {
            text: '',
            value: 'image',
            width: '5%',
            sortable: false,
          },
          {
            text: 'SKU',
            value: 'sku',
            width: '10%',
            sortable: false,
          },
          {
            text: 'EAN',
            value: 'ean',
            width: '14%',
            sortable: false,
          },
          {
            text: 'Nome',
            value: 'name',
            width: '30%',
            sortable: false,
          },
          {
            text: 'Preço 1',
            value: 'price_1',
            width: '9%',
            sortable: false,
          },
          { ...cashbackOrPoints },
          {
            text: 'Mín. CPF',
            value: 'minimum_per_client',
            width: '10%',
            sortable: false,
          },
          {
            text: 'Máx. CPF',
            value: this.offerSalesType === 'next_buy_cashback_offer_sales' ? 'max_coupons' : 'maximum_per_client',
            width: '10%',
            sortable: false,
          },
          ...(this.isFranchise
            ? [
                {
                  text: 'Franq.',
                  value: 'franchisee_products',
                  sortable: false,
                },
              ]
            : []),
          {
            text: 'Status',
            value: 'status',
            sortable: false,
          },
        ]
      }

      if (this.offerSalesType === 'next_buy_cashback_offer_sales') {
        const indexToRemove = headers.findIndex((h) => h.value === 'price_1')
        headers.splice(indexToRemove, 1)
      }

      return headers
    },
    getComponent() {
      const components = {
        offer_sales: AbsoluteDiscountTable,
        percentage_offer_sales: PercentageDiscountTable,
        dynamic_pricing_percentage_offer_sales: DynamicPricingPercentageDiscountTable,
        takepay_offer_sales: TakePayTable,
        cashback_percentage_offer_sales: CashbackAndPointsTable,
        cashback_absolute_offer_sales: CashbackAndPointsTable,
        points_offer_sales: CashbackAndPointsTable,
        next_buy_cashback_offer_sales: CashbackAndPointsTable,
      }

      return components[this.offerSalesType]
    },
  },
}
</script>

<style lang="scss" scoped>
hr {
  border: 1px solid $cinza-l60;
  margin: 0 -25px !important;
}
</style>
